<template>
    <div
        :class="{ 'large-text': largeText }"
        class="cz2__calendar-add-remove-button"
    >
        <btn
            v-if="!calendarInCart"
            @click="addHolidayCalendar"
            primary
            class="cz2__full-width"
        >
            {{ addButtonCopy }}
        </btn>

        <btn
            v-else
            gray
            @click="removeHolidayCalendar"
            class="cz2__full-width"
        >
            <img
                v-if="showIcon"
                src="../assets/icons/trash-icon.svg"
                width="20"
                height="20"
                aria-hidden="true"
                :class="{ 'hide-on-xs': hideIconMobile }"
            />
            {{ $t('CALENDAR_CTA_REMOVE') }}
        </btn>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    #cz2.cz2 {
        .cz2__calendar-add-remove-button {
            .cz2__btn {
                width: 100%;
                display: flex;
                gap: 10px;
                padding-left: 16px;
                padding-right: 16px;
            }

            &:hover {
                font-size: 16px;
            }

            &.large-text {
                .cz2__btn {
                    font-size: 22px;
                }
            }

            @media (max-width: 460px) {
                .hide-on-xs {
                    display: none;
                }
            }
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            Btn,
        },

        props: {
            largeText: {
                type: Boolean,
                default: false,
            },

            isCard: {
                type: Boolean,
                default: false,
            },

            showPrice: {
                type: Boolean,
                default: true,
            },

            showIcon: {
                type: Boolean,
                default: true,
            },

            hideIconMobile: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            calendarInCart() {
                return this.$store.getters.holidayCalendarInCart;
            },

            availableHolidayCalendar() {
                return this.$store.getters.availableHolidayCalendar;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            price() {
                if (this.availableHolidayCalendar) {
                    const price = this.viewController.getPrice(this.availableHolidayCalendar);

                    return formatPrice(this.$store.state, price, 'noDigits');
                }

                return '';
            },

            addButtonCopy() {
                const price = this.showPrice ? ` + ${this.price}` : '';
                const addCopy = this.isCard ? this.$t('CALENDAR_CARD_CTA_ADD') : this.$t('CALENDAR_CTA_ADD');
                const ctaCopy = this.isMobile ? this.$t('CALENDAR_CTA_ADD_MOBILE') : addCopy;

                return `${ctaCopy}${price}`;
            },

            showCalendarModal() {
                return this.$store.state.showCalendarModal;
            },

            isMobile() {
                return this.$store.state.customizer.isMobile;
            },
        },

        methods: {
            addHolidayCalendar() {
                const pack = this.viewController.findPlacement('POPHolidayCalendar');

                if (pack) {
                    const toSelect = pack.components.find((x) => !x.placeholder && this.viewController.isAvailable(x));

                    if (toSelect) {
                        this.viewController.updateComponent(pack.code, toSelect.code);
                    }
                }

                this.closeInfoModal();
            },

            removeHolidayCalendar() {
                const pack = this.viewController.findPlacement('POPHolidayCalendar');

                if (pack) {
                    const toSelect = pack.components.find((x) => x.placeholder);

                    if (toSelect) {
                        this.viewController.updateComponent(pack.code, toSelect.code);
                    }
                }

                this.closeInfoModal();
            },

            closeInfoModal() {
                if (this.showCalendarModal) {
                    this.$store.dispatch('setShowCalendarModal', false);
                }
            },
        },
    };
</script>
